import styled, { css } from "styled-components";

interface IBillboardLoadingContainerProps {
  show: boolean;
  stopTextAnimation: boolean;
}

export const BillboardLoadingContainer = styled.div<IBillboardLoadingContainerProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100%;
  gap: 1.5rem;

  color: white;
  background-color: black;

  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;

  pointer-events: none;
  opacity: 0;

  transition: 0.3s all;

  ${({ show }) =>
    show &&
    css`
      pointer-events: all;
      opacity: 1;
    `}

  img {
    border-radius: 8px;
  }

  .text-scroller {
    position: relative;
    width: 100%;
    height: 40px;
    overflow: hidden;

    display: flex;
    align-items: center;
  }

  .text {
    position: absolute;
    width: 100%;

    ${({ stopTextAnimation }) =>
      !stopTextAnimation &&
      css`
        animation: slide 3s ease-in-out infinite;
      `}

    text-align: center;
  }

  @keyframes slide {
    0% {
      transform: translateY(100%);
      opacity: 0;
    }
    10% {
      transform: translateY(0);
      opacity: 1;
    }
    90% {
      transform: translateY(0);
      opacity: 1;
    }
    100% {
      transform: translateY(-100%);
      opacity: 0;
    }
  }
`;

interface IProgressBarProps {
  value: number;
}

export const ProgressBar = styled.div<IProgressBarProps>`
  height: 4px;

  background-color: white;
  border-radius: 4px;
  overflow: hidden;

  max-width: 300px;
  width: 100%;

  position: relative;

  ::before {
    content: "";
    height: 100%;
    width: ${({ value }) => value}%;
    transition: 0.3s all;

    position: absolute;
    top: 0;
    left: 0;
    background: #605cff;
  }
`;
